import { observeValue } from 'helpers/observe'

export const fancyBoxReady = (cb = () => {}) => {
  observeValue(() => window?.$?.fancybox)
    .then((res) => {
      cb()
    })
    .catch((err) => {
      console.log('Load fancy box error: ', err)
    })
}
